import { StackProps, VStack } from '@elkaso-app/web-design';
import { PhoneNumber } from '../../../components/base-table';

export interface IPocClientPhoneNumberCell extends StackProps {
  phoneNumber: string;
}

export const PocClientPhoneNumberCell = ({ phoneNumber, ...rest }: IPocClientPhoneNumberCell) => {
  return (
    <VStack spacing='sm' align='start' {...rest}>
      <PhoneNumber value={phoneNumber} />
    </VStack>
  );
};
